import { fetchAPI } from "features/cms";
import { logError } from "features/logger";

const defaultValue = {
  header: {},
  footer: {},
};

export const fetchMenusData = async (locale) => {
  try {
    const res = await fetchAPI("/menus", {
      populate: "*",
      filters: {
        slug: {
          $in: [`header-${locale}`, `footer-${locale}`],
        },
      },
      nested: true,
    });

    // Нормалізація відповіді меню. Strapi 4.26 + strapi-plugin-menus повертає
    // v4-формат (item як {id, attributes}, зв'язки як {data:[...]}), тоді як
    // фронт очікує плоскі об'єкти з масивами. Обробляємо ОБИДВА формати.
    const flattenItem = (item) => {
      const a = item?.attributes ?? item ?? {};
      const childrenRaw = a.children?.data ?? a.children ?? [];
      return {
        id: item?.id ?? a.id,
        ...a,
        children: Array.isArray(childrenRaw)
          ? childrenRaw.map(flattenItem)
          : [],
      };
    };
    const flattenMenu = (menu) => {
      if (!menu) return {};
      const a = menu?.attributes ?? menu ?? {};
      const itemsRaw = a.items?.data ?? a.items ?? [];
      return {
        id: menu?.id ?? a.id,
        ...a,
        items: Array.isArray(itemsRaw) ? itemsRaw.map(flattenItem) : [],
      };
    };
    const menus = Array.isArray(res?.data) ? res.data.map(flattenMenu) : [];

    const currentHeader =
      menus.find(({ slug }) => slug === `header-${locale}`) ?? {};

    const currentFooter =
      menus.find(({ slug }) => slug === `footer-${locale}`) ?? {};

    return Promise.resolve({
      data: {
        header: currentHeader,
        footer: currentFooter,
      },
      error: null,
    });
  } catch (e) {
    logError(e, {
      scope: "fetchMenusData",
      collection: "menus",
      locale,
    });
    return Promise.resolve({
      data: defaultValue,
      error: {
        status: e.status,
      },
    });
  }
};
